export const DEFAULT_AGE = '21'
